// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";
import Host from "./Host";

export default function HelmetComponent({ title, metaTitle, metaDescription }) {
  return (
    <Helmet>
      <title>{`${title ? title : ""} ${title && "|"} ${metaTitle || Host?.metaTitle}`}</title>
      <meta name="description" content={metaDescription || Host?.metaDescription} />
    </Helmet>
  );
}
